import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { FaApple, FaAndroid } from 'react-icons/fa';
import { elakayAutoText } from '../pageInside/dataElakay';
import { MOBILE_APP_SETTINGS, resolveMobileAppAction } from '../../utils/mobileAppSettings';
import './FooterMobileApp.css';

// Footer "Mobile App" entry point: a single button carrying both the
// Apple and Android marks (never two separate buttons). Today
// MOBILE_APP_SETTINGS always resolves to the "Coming Soon" modal below —
// see src/utils/mobileAppSettings.js for how a future config flip (no
// component change) turns this into a real per-platform Store redirect.
const FooterMobileApp = () => {
  const [showComingSoon, setShowComingSoon] = useState(false);

  const buttonLabel = elakayAutoText('h_18c57b82daff28', 'Elakay Mobile App');
  const appleLabel = elakayAutoText('h_fff02aa5993a91', 'Apple App Store');
  const androidLabel = elakayAutoText('h_da68b612ec3605', 'Google Play');
  const closeLabel = elakayAutoText('h_bbfa773e5a63a5', 'Close');

  const handleClick = () => {
    const action = resolveMobileAppAction(MOBILE_APP_SETTINGS);
    if (action.type === 'redirect' && action.url) {
      window.open(action.url, '_blank', 'noopener,noreferrer');
      return;
    }
    setShowComingSoon(true);
  };

  return (
    <div className="footer-mobile-app">
      <button
        type="button"
        className="footer-mobile-app__btn"
        onClick={handleClick}
        aria-label={buttonLabel}
        aria-haspopup="dialog"
      >
        <span className="footer-mobile-app__icons" aria-hidden="true">
          <FaApple className="footer-mobile-app__icon footer-mobile-app__icon--apple" />
          <FaAndroid className="footer-mobile-app__icon footer-mobile-app__icon--android" />
        </span>
        <span className="footer-mobile-app__label">{buttonLabel}</span>
      </button>

      <Modal
        show={showComingSoon}
        onHide={() => setShowComingSoon(false)}
        centered
        dialogClassName="footer-mobile-app-modal"
        backdropClassName="footer-mobile-app-modal-backdrop"
        aria-labelledby="footer-mobile-app-modal-title"
      >
        <Modal.Body className="footer-mobile-app-modal__body text-center">
          <div className="footer-mobile-app-modal__icons">
            <FaApple className="footer-mobile-app-modal__icon" role="img" aria-label={appleLabel} />
            <FaAndroid className="footer-mobile-app-modal__icon" role="img" aria-label={androidLabel} />
          </div>
          <h2 id="footer-mobile-app-modal-title" className="footer-mobile-app-modal__title">
            {buttonLabel}
          </h2>
          <p className="footer-mobile-app-modal__subtitle">
            {elakayAutoText(
              'h_798498380c67ea',
              'Our Elakay mobile apps for Users and Royalty Users are currently in development.'
            )}
          </p>
          <p className="footer-mobile-app-modal__coming-soon">
            {elakayAutoText('h_04d2fd852a2b48', 'Coming Soon')}
          </p>
          <p className="footer-mobile-app-modal__description">
            {elakayAutoText(
              'h_2e43af7f762493',
              'A faster, more modern and more powerful mobile experience is being prepared.'
            )}
          </p>
          <button
            type="button"
            className="footer-mobile-app-modal__close-btn"
            onClick={() => setShowComingSoon(false)}
          >
            {closeLabel}
          </button>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default FooterMobileApp;
